var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Switch } from '@headlessui/react';
import { classNames } from '@web/utility';
var Toggle = function (_a) {
    var enabled = _a.enabled, _b = _a.enabledColor, enabledColor = _b === void 0 ? 'bg-indigo-600' : _b, onChange = _a.onChange, disabled = _a.disabled, className = _a.className, id = _a.id;
    return (_jsx(Switch, __assign({ id: id, checked: enabled, onChange: !disabled ? onChange : function () { }, className: classNames(enabled ? enabledColor : 'bg-gray-200', !disabled
            ? 'cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
            : 'cursor-not-allowed', 'relative inline-flex flex-shrink-0 h-4 w-7 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200', className) }, { children: _jsx("span", { "aria-hidden": "true", style: { width: '10px', height: '10px', marginTop: '1.2px' }, className: classNames(enabled ? 'translate-x-3' : 'translate-x-0', 'pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200') }) })));
};
export default Toggle;
